export const useCrumbs = (ServerRelativeUrl) => {

    var crumbstring = ServerRelativeUrl.replace('/sites/PublicWebsiteDocuments/', "");
  //   console.log(crumbstring); 
    var crumbarray = crumbstring.split("/");
    const arr = [];
    var current = "?path="; 

    for (var i =0; i < crumbarray.length; i++)
    {
        current += "/" + crumbarray[i];
        arr.push({"name": crumbarray[i],href: current, isSeperator: false,  disabled: i+1 === crumbarray.length ? true: false}) 
        if (i+1 !== crumbarray.length) {
            arr.push({"name": " > ", isSeperator: true,  href:"", disabled: true})
        }
    }

    return arr;

}

